const { default: ApparelBom } = require("./Model/ApparelBom");

define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/table/ApplySort",
	"csi/table/Widget",
	"csi/view",
	"csi/xml"
], function(declare, lang, when, ApplySort, TableWidget, csiView, xml) {

	var _ApplySort = declare(ApplySort, {
		process: function() {
			// summary: DE29070 call BOMRepositionProductColors server operation to update the indexes of svereal attributes in part materials
			this.setProgress();

			var qr = this.widget.getQueryResult();

			when(qr.store.getFullRequest(),
				lang.hitch(this, function(urls) {
					this.m_writer.callMethod("Specification", "BOMRepositionProductColors")
						.addParameter(xml.PROP_URL, xml.ATTR_REF, qr.url)
						.addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, urls);
					this.publish();
				}),
				lang.hitch(this, this._onPublishError)
			);
		},

		postProcessSuccess: function() {
			// summary: override parent behavior to refresh table after removing sort headers because view is already accurate
			this.widget.set("sortSettings", []);
			this.widget.showSortHeaders();
		}
	});

	return declare(TableWidget, {
		_actionControllers: {
			TableApplySort: _ApplySort
		},

		/**
		 * @override
		 * Make the view read-only if the BOM is a source BOM
		 */
		_resolveView() {
			this.inherited(arguments);
			const bom = this.cacheView.getPathNode(this.urlRoot, "Child:__Parent__");
			const isSourceBOM = ApparelBom.isSourceBOM(bom);
			if (isSourceBOM) {
				this.defView.bReadOnly = true;
			}
		},

		/**
		 * Handle color(s) being added
		 * @param {Controller} ac
		 */
		postActionAddColors(ac) {
			this._postActionUpdatePartMaterials();
		},

		/**
		 * Handle color being removed
		 * @param {Controller} ac
		 */
		postActionRemoveColor(ac) {
			this._postActionUpdatePartMaterials(ac.m_urlNode);
		},

		/**
		 * Notify PartMaterials view of changes to colors
		 * @param {cnl} removedColorUrl
		 */
		_postActionUpdatePartMaterials(removedColorUrl) {
			const update = (view) => {
				view.refreshOnTabSwitch = true;

				if (removedColorUrl) {
					view.removeBomColor(removedColorUrl);
				}
			};

			csiView.getAllViews("PartMaterials")?.forEach(update);
			csiView.getAllViews("HierarchicalPartMaterials")?.forEach(update);
		},
	});
});
